import { Badge } from '@/components/ui/badge';
import { getResourceTypeBucket } from '@/lib/resource-types';

const BUCKET_VARIANTS: Record<string, 'outline' | 'secondary' | 'default'> = {
  person: 'outline',
  contractor: 'secondary',
  asset: 'default',
};

interface ResourceTypeBadgeProps {
  type: string | undefined | null;
  className?: string;
}

/**
 * The People / Contractor / Assets badge shown wherever a resource's type is
 * displayed — planner rows, booking pickers and the resource directory.
 */
export function ResourceTypeBadge({ type, className }: ResourceTypeBadgeProps) {
  const bucket = getResourceTypeBucket(type);

  return (
    <Badge
      variant={BUCKET_VARIANTS[bucket.value] ?? 'outline'}
      className={className ?? 'text-[10px] px-1.5 py-0 h-5 font-medium'}
    >
      {bucket.label}
    </Badge>
  );
}
